"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleMetaInfo = void 0;
exports.isRtl = isRtl;
const i18n_core_1 = require("@medable/i18n-core");
const locales_1 = require("./locales");
/**
 * Map of language to whether it is RTL. Taken from {@link https://help.smartling.com/hc/en-us/articles/1260802028830-Right-to-left-RTL-Locales smartling.com}.
 */
const isRtlMap = {
    [locales_1.Locale.af_ZA]: false,
    [locales_1.Locale.ar_AE]: true,
    [locales_1.Locale.ar_DZ]: true,
    [locales_1.Locale.ar_EG]: true,
    [locales_1.Locale.ar_IL]: true,
    [locales_1.Locale.ar_KW]: true,
    [locales_1.Locale.ar_LB]: true,
    [locales_1.Locale.ar_QA]: true,
    [locales_1.Locale.ar_SA]: true,
    [locales_1.Locale.as_IN]: false,
    [locales_1.Locale.bg_BG]: false,
    [locales_1.Locale.bn_IN]: false,
    [locales_1.Locale.bs_Latn_BA]: false,
    [locales_1.Locale.ca_ES]: false,
    [locales_1.Locale.ceb_PH]: false,
    [locales_1.Locale.cs_CZ]: false,
    [locales_1.Locale.da_DK]: false,
    [locales_1.Locale.de_AT]: false,
    [locales_1.Locale.de_BE]: false,
    [locales_1.Locale.de_CH]: false,
    [locales_1.Locale.de_DE]: false,
    [locales_1.Locale.el_GR]: false,
    [locales_1.Locale.en_AU]: false,
    [locales_1.Locale.en_BE]: false,
    [locales_1.Locale.en_CA]: false,
    [locales_1.Locale.en_GB]: false,
    [locales_1.Locale.en_HK]: false,
    [locales_1.Locale.en_IE]: false,
    [locales_1.Locale.en_IL]: false,
    [locales_1.Locale.en_IN]: false,
    [locales_1.Locale.en_JM]: false,
    [locales_1.Locale.en_MY]: false,
    [locales_1.Locale.en_NZ]: false,
    [locales_1.Locale.en_PH]: false,
    [locales_1.Locale.en_SG]: false,
    [locales_1.Locale.en_TW]: false,
    [locales_1.Locale.en_US]: false,
    [locales_1.Locale.en_ZA]: false,
    [locales_1.Locale.es_419]: false,
    [locales_1.Locale.es_AR]: false,
    [locales_1.Locale.es_CL]: false,
    [locales_1.Locale.es_CO]: false,
    [locales_1.Locale.es_CR]: false,
    [locales_1.Locale.es_DO]: false,
    [locales_1.Locale.es_ES]: false,
    [locales_1.Locale.es_GT]: false,
    [locales_1.Locale.es_MX]: false,
    [locales_1.Locale.es_PA]: false,
    [locales_1.Locale.es_PE]: false,
    [locales_1.Locale.es_PR]: false,
    [locales_1.Locale.es_US]: false,
    [locales_1.Locale.et_EE]: false,
    [locales_1.Locale.fi_FI]: false,
    [locales_1.Locale.fil_PH]: false,
    [locales_1.Locale.fr_BE]: false,
    [locales_1.Locale.fr_CA]: false,
    [locales_1.Locale.fr_CH]: false,
    [locales_1.Locale.fr_DZ]: false,
    [locales_1.Locale.fr_FR]: false,
    [locales_1.Locale.gl_ES]: false,
    [locales_1.Locale.gu_IN]: false,
    [locales_1.Locale.he_IL]: true,
    [locales_1.Locale.hi_IN]: false,
    [locales_1.Locale.hil_PH]: false,
    [locales_1.Locale.hr_HR]: false,
    [locales_1.Locale.ht_HT]: false,
    [locales_1.Locale.hu_HU]: false,
    [locales_1.Locale.ilo_PH]: false,
    [locales_1.Locale.it_CH]: false,
    [locales_1.Locale.it_IT]: false,
    [locales_1.Locale.ja_JP]: false,
    [locales_1.Locale.ka_GE]: false,
    [locales_1.Locale.kn_IN]: false,
    [locales_1.Locale.ko_KR]: false,
    [locales_1.Locale.lt_LT]: false,
    [locales_1.Locale.lv_LV]: false,
    [locales_1.Locale.ml_IN]: false,
    [locales_1.Locale.mr_IN]: false,
    [locales_1.Locale.ms_Arab_MY]: true,
    [locales_1.Locale.ms_Latn_MY]: false,
    [locales_1.Locale.ms_Latn_SG]: false,
    [locales_1.Locale.nb_NO]: false,
    [locales_1.Locale.nl_BE]: false,
    [locales_1.Locale.nl_NL]: false,
    [locales_1.Locale.nso_ZA]: false,
    [locales_1.Locale.or_IN]: false,
    [locales_1.Locale.pa_Guru_IN]: false,
    [locales_1.Locale.pl_PL]: false,
    [locales_1.Locale.pt_BR]: false,
    [locales_1.Locale.pt_PT]: false,
    [locales_1.Locale.ro_MD]: false,
    [locales_1.Locale.ro_RO]: false,
    [locales_1.Locale.ru_EE]: false,
    [locales_1.Locale.ru_IL]: false,
    [locales_1.Locale.ru_LT]: false,
    [locales_1.Locale.ru_LV]: false,
    [locales_1.Locale.ru_RU]: false,
    [locales_1.Locale.ru_UA]: false,
    [locales_1.Locale.sk_SK]: false,
    [locales_1.Locale.sl_SI]: false,
    [locales_1.Locale.sr_Cyrl_RS]: false,
    [locales_1.Locale.sr_Latn_RS]: false,
    [locales_1.Locale.st_ZA]: false,
    [locales_1.Locale.sv_FI]: false,
    [locales_1.Locale.sv_SE]: false,
    [locales_1.Locale.ta_IN]: false,
    [locales_1.Locale.ta_MY]: false,
    [locales_1.Locale.ta_SG]: false,
    [locales_1.Locale.te_IN]: false,
    [locales_1.Locale.th_TH]: false,
    [locales_1.Locale.tl_PH]: false,
    [locales_1.Locale.tn_ZA]: false,
    [locales_1.Locale.tr_TR]: false,
    [locales_1.Locale.uk_UA]: false,
    [locales_1.Locale.ur_IN]: true,
    [locales_1.Locale.ur_PK]: true,
    [locales_1.Locale.vi_VN]: false,
    [locales_1.Locale.xh_ZA]: false,
    [locales_1.Locale.zh_Hans_CN]: false,
    [locales_1.Locale.zh_Hans_MY]: false,
    [locales_1.Locale.zh_Hans_SG]: false,
    [locales_1.Locale.zh_Hant_HK]: false,
    [locales_1.Locale.zh_Hant_TW]: false,
    [locales_1.Locale.zu_ZA]: false,
    // Pseudo-locales
    [locales_1.Locale.en_XA]: false,
    [locales_1.Locale.ar_XB]: true,
};
const getLocaleMetaInfo = ({ appLocale = locales_1.Locale.en_US, targetLocale, }) => {
    const language = new i18n_core_1.DisplayNamesLanguage(appLocale).of(targetLocale);
    const localeSplit = targetLocale.split('-');
    const regionCode = localeSplit[localeSplit.length - 1];
    const region = new i18n_core_1.DisplayNamesRegion(appLocale).of(regionCode);
    return { region, language };
};
exports.getLocaleMetaInfo = getLocaleMetaInfo;
/**
 * @returns Whether the given language should be displayed in right-to-left.
 */
function isRtl(language) {
    return isRtlMap[language];
}
//# sourceMappingURL=locales.utils.js.map